import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useUser } from "@nju/data-access-portal-user";
import { ErrorMessage, Input } from "@nju/form";
import { portalRoutes } from "@nju/routes";
import { A, Button, Heading, Panel, Separator } from "@nju/ui";
import { changeEmailMachine } from "./changeEmail.machine";

export function DashboardUserChangeEmailPage() {
  const { email: oldEmail } = useUser();
  const router = useRouter();

  const [{ context, matches }, send] = useMachine(changeEmailMachine, {
    actions: {
      onSuccessSend: () => {
        return router.push(
          portalRoutes.mojeKonto.mojProfil.zmienAdresEmail.wiadomoscWyslana.get(),
        );
      },
      onErrorSend: () => {
        return router.push(
          portalRoutes.mojeKonto.mojProfil.zmienAdresEmail.blad.get(),
        );
      },
    },
    context: { oldEmail },
  });

  const onSetEmail = React.useCallback(
    (email: string) => {
      send({ type: "SET_EMAIL", email });
    },
    [send],
  );

  return (
    <Panel>
      <Heading font="ttfirs" tone="neutral" variant="h2" weight="bold">
        podaj nowy adres e-mail
      </Heading>
      <Separator size="l" tone="invisible" />
      <div className="from-tablet:max-w-[508px]">
        <Input
          inputMode="email"
          label="adres e-mail"
          name="email"
          onValueChange={onSetEmail}
          state={context.emailError ? "error" : undefined}
        />
      </div>
      {context.emailError && (
        <>
          <Separator size="xxs" tone="invisible" />
          <ErrorMessage message={context.emailError} />
        </>
      )}
      <Separator size="m" tone="invisible" />
      <div className="flex flex-col-reverse only-mobile:gap-3 from-tablet:flex-row from-tablet:justify-between">
        <Link
          href={portalRoutes.mojeKonto.mojProfil.index.get()}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }} variant="secondary">
            anuluj
          </A>
        </Link>
        <Button
          isLoading={!matches("ready")}
          onPress={() => {
            send("SUBMIT");
          }}
          size={{ "@onlyMobile": "s" }}
          testId="save-new-email"
        >
          zapisz
        </Button>
      </div>
    </Panel>
  );
}
